export default {
  SET_REQUIRED: 'SET_REQUIRED',
  SET_ANALYTICS: 'SET_ANALYTICS',
  SET_MARKETING: 'SET_MARKETING',
  SET_FACEBOOK_PIXEL: 'SET_FACEBOOK_PIXEL',
  SET_ACCEPT_ALL_URL: 'SET_ACCEPT_ALL_URL',
  SET_ACCEPT_SELECTED_URL: 'SET_ACCEPT_SELECTED_URL',
}
